import type * as Highcharts from 'highcharts';
import type { MutableRefObject } from 'react';

export type TooltipElementRef = MutableRefObject<Highcharts.SVGElement | undefined>;

interface RenderTooltipParams {
  renderer: Highcharts.SVGRenderer | undefined;
  html: string;
  x: number;
  y: number;
  ref: TooltipElementRef;
}

export const renderTooltip = ({ renderer, html, x, y, ref }: RenderTooltipParams): void => {
  if (!renderer) {
    return;
  }

  if (ref.current) {
    ref.current.destroy();
  }

  ref.current = renderer
    .label(html, x, y, 'callout', 0, 0, true)
    .shadow({
      color: 'rgba(0, 0, 0, 0.1)',
      opacity: 0.3,
      width: 15,
    })
    .attr({
      fill: '#fff',
      borderColor: '#fff',
      zIndex: 20,
      padding: 20,
      r: 8,
    })
    .css({
      color: '#000000',
      fontSize: '0.8em',
      fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
      fontWeight: '400',
      transition: 'opacity 0.5s',
    })
    .add();
};

export const destroyTooltip = (ref: TooltipElementRef): void => {
  if (ref.current) {
    ref.current.destroy();
    ref.current = undefined;
  }
};
